import {useState, useEffect} from 'react';

const breakpoint = (screenSize) => {
  switch (screenSize) {
    case 'small':
      return '640px';
    case 'medium':
      return '832px';
    case 'large':
      return '1024px';
    case 'xlarge':
      return '1216px';  
    default:
      throw new Error(`Invalid screen size: ${screenSize}`);
  }
};

export default function (screenSize) {
  const [isBelowBreakpoint, setIsBelowBreakpoint] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      const mediaQuery = window.matchMedia(`(max-width: ${breakpoint(screenSize)})`);
      setIsBelowBreakpoint(mediaQuery.matches);

      const handleResize = (e) => {
        setIsBelowBreakpoint(e.matches);
      };

      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', handleResize);
      }

      return () => {
        if (mediaQuery.removeEventListener) {
          mediaQuery.removeEventListener('change', handleResize);
        }
      };
    }
  }, []);

  return isBelowBreakpoint;
}
